var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { AttachedTrait } from '../attachedtrait/AttachedTrait';
import { AttachedSkeletonContext } from '../../context/attached/AttachedSkeletonContext';
import { registry } from '../../../registry/Registry';
import { runtime } from '../../runtime/Runtime';
export class AttachedSkeletonTrait extends AttachedTrait {
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get skeletonReg() {
        return registry.skeletonRegistry.registry_object[this.trait.value];
    }
    get attachedSkeletonEdit() {
        return new runtime.solidPackages.Edit.classes.AttachedSkeletonTraitEdit(this);
    }
    get aspectsTemplate() {
        return this.attachedSkeletonEdit.mergeSkeletonTemplate(super.aspectsTemplate);
    }
    get skeletonResultingFromAttachedTrait() {
        const { attachedValue } = this;
        if (typeof attachedValue === 'object' && !!attachedValue.$$typeof) {
            // React Element
            return attachedValue;
        }
        if (!this.skeletonReg)
            return null;
        const jsxSkeleton = this.skeletonReg.jsx;
        if (typeof jsxSkeleton !== 'function') {
            return jsxSkeleton;
        }
        const skeletonContext = new AttachedSkeletonContext(this);
        return jsxSkeleton(skeletonContext);
    }
    get componentResultingFromAttachedTrait() {
        return this.aspect.actor.actorRenderer.aspectifyJsxTemplate(this.skeletonResultingFromAttachedTrait);
    }
    wrapAspect(aspectComponent) {
        if (!this.skeletonReg) {
            return aspectComponent;
        }
        if (typeof this.skeletonReg.jsx === 'function') {
            const skeletonContext = new AttachedSkeletonContext(this, { aspectComponent });
            return this.skeletonReg.jsx(skeletonContext);
        }
        return aspectComponent;
    }
    wrapChildren(aspectChildren) {
        if (!this.skeletonReg)
            return aspectChildren;
        if (typeof this.skeletonReg.jsx === 'function') {
            const skeletonContext = new AttachedSkeletonContext(this, { aspectChildren });
            return this.skeletonReg.jsx(new AttachedSkeletonContext(this, skeletonContext));
        }
        return aspectChildren;
    }
}
__decorate([
    computed
], AttachedSkeletonTrait.prototype, "skeletonResultingFromAttachedTrait", null);
__decorate([
    computed
], AttachedSkeletonTrait.prototype, "componentResultingFromAttachedTrait", null);
